import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import { InputDropDown } from '@sm360/widget-commons-forms';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';

import 'react-dropdown/style.css';

const { PaymentFrequencies, PaymentFrequencyService } = PurchaseMethods;

const CustomizePaymentFrequency = ({ purchaseMethods, onPaymentFrequencyClick }) => {
    const frequencyOptions = PaymentFrequencyService.getPaymentFrequencyDropDownValues(LocaleService, purchaseMethods);
    const selectedFrequency = find(frequencyOptions, { value: purchaseMethods.getSelectedFinancePaymentFrequency() });
    const onChange = (paymentFrequency) => onPaymentFrequencyClick(paymentFrequency, paymentFrequency.label);
    return (
        <div className="customize-payment-frequency">
            <InputDropDown
                name="paymentFrequencies"
                options={frequencyOptions}
                value={selectedFrequency ? selectedFrequency.value : PaymentFrequencies.MONTHLY}
                valueChange={onChange}
                classNames={['sr-paymentCalculator-dropdown']}
            />
        </div>
    );
};

CustomizePaymentFrequency.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
    onPaymentFrequencyClick: PropTypes.func.isRequired,
};

CustomizePaymentFrequency.displayName = 'CustomizePaymentFrequency';

export default CustomizePaymentFrequency;



// WEBPACK FOOTER //
// ./src/components/PaymentCalculatorDetails/components/CustomizePayment/CustomizePaymentFrequency.jsx